import { Modal } from '@simplywallst/ui-core';

interface Props {
  handleCloseModal: () => void;
  errorMessage?: string;
  errorCode?: string;
}

export const BillingErrorModal = ({
  handleCloseModal,
  errorMessage,
  errorCode,
}: Props) => {
  return (
    <Modal
      key="error"
      title="Error"
      onPrimaryClick={handleCloseModal}
      primaryLabel="Close"
      onSecondaryClick={handleCloseModal}
    >
      <p data-cy-id="billing-modal-desc">
        An unexpected error has occurred. Please try again later.
        {errorMessage && errorCode && `[${errorCode}]:${errorMessage}`}
      </p>
    </Modal>
  );
};
